module.exports = __webpack_public_path__ + "static/media/rocket_launch_.4b3c1d6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/rocket_launch_.png
// module id = 125
// module chunks = 0